export const CLIENT_SETTINGS_ENDPOINTS = {
  getClientSettings: (key: string) => `/api/shared/ClientSettings?key=${key}`,
  saveClientSettings: () => '/api/shared/ClientSettings',
} as const;